'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";

import Alert from "react-bootstrap/Alert";

import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";
import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {withRouter} from "@uw-it-sis/lib-react/lib/WithRouter";

import viewIdentifierStore from "./ViewIdentifierStore";
import Registration from "../registration/Registration";
import PlanView from "../plan/PlanView";
import {PlanViewType} from "../lib/Constants";

class ViewIdentifier extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = viewIdentifierStore;
    }

    componentDidMount() {
        this.store.mount();
    }

    componentWillUnmount() {
        this.store.unmount();
    }

    buildDoneComponent = () => {
        let view; // for setting which view will be shown (reg/plan/error)
        let component; // component to return for the view
        let identifier; // for reg view
        let anchor; // for plan view anchoring to term in mobile
        let academicYear; // for plan view
        let year; // for plan view navigation
        const params = this.props.params;
        const currentPlanableTerm = this.store.getCurrentPlanableTerm();

        if ( ! params.identifier ) {
            // If no identifier in params - default to current planable academic year
            academicYear = TermUtils.getAcademicYearCode(currentPlanableTerm.id, TermUtils.SIZE.LONG);
            year = academicYear.substring(0, 4);
            view = PlanViewType.plan;
        } else {
            identifier = params.identifier;
            // anchor would be the term within academic year to anchor to (only valuable in smaller screen views)
            anchor = params.anchor;

            let termId;

            // Check if identifier is a valid term
            if ( ! TermUtils.isValidFormattedTermId(identifier) ) {
                termId = TermUtils.makeTermIdFromTermName(identifier);
            } else {
                termId = identifier;
                identifier = TermUtils.makeTermLinkIdentifierFromTermId(termId);
            }

            // If a valid term, is published, use reg view
            if (termId) {
                if ( this.store.isPublished(termId) ) {
                    // term id is valid and term is published
                    view = PlanViewType.reg;
                } else {
                    // term is not published so give plan view in academic year of term
                    academicYear = TermUtils.getAcademicYearCode(termId, TermUtils.SIZE.LONG);
                    year = academicYear.substring(0, 4);
                    view = PlanViewType.plan;
                }
            } else {
                // If identifier is an academic year - go to that academic year
                if (this.store.isValidAcademicYear(identifier)) {
                    year = identifier.substring(0, 4);
                    academicYear = TermUtils.getAcademicYearCode(`${year}4`, TermUtils.SIZE.LONG);
                    view = PlanViewType.plan;
                } else {
                    view = "errorView";
                }
            }
        }

        let relatedLinkList = [
            {
                label: "Course Search",
                href: "/course",
                router: false
            },
            {
                label: "Schedule Builder",
                href: `/schedule`,
                router: true
            },
            {
                label: "Plan Audit",
                href: "/audit/#/plan",
                router: false
            }
        ];
        if ( appStore.isStudent() || appStore.isAdviser() ) {
            relatedLinkList.splice(2, 0, {
                label: "Degree Audit (DARS)",
                href: "/audit/#/degree",
                router: false
            })
        }

        switch (view) {
            default:
            case PlanViewType.plan:
                component = <PlanView academicYear={academicYear} scrollTo={anchor} prev={this.store.getPlanNavigationPrev(year)} next={this.store.getPlanNavigationNext(year)} relatedLinks={relatedLinkList} />;
                break;
            case PlanViewType.reg:
                component = <Registration identifier={identifier} relatedLinks={relatedLinkList} />;
                break;
            case "errorView":
                component =
                    <Alert variant="danger" className="mt-4">
                        Oops... Something went wrong!
                    </Alert>;
                break;
        }

        return component;
    }

    render() {
        return (
            <SimpleState state={this.store.state}
                         doneComponentBuilder={this.buildDoneComponent}
                         pendingComponentBuilder="dots"
                         name="ViewIdentifier"/>
        );
    }
}

export default withRouter(observer(ViewIdentifier));